import React from 'react'
import { Box, MenuItem } from '@mui/material'
import Select, { Icon } from '@/components/common/Select'

import BitcoinSvg from '@/assets/imgs/bitcoin.svg'

const BtcSelect = ({ tag }: { tag: string }) => {
  return (
    <Select defaultValue="Bitcoin" tag={tag} renderIcon={() => <Icon src={BitcoinSvg} alt="bitcoin" />}>
      <MenuItem sx={{ width: '100%', height: 60 }} value="Bitcoin">
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
          <Icon src={BitcoinSvg} alt="bitcoin" />
          Bitcoin
        </Box>
      </MenuItem>
    </Select>
  )
}

export default BtcSelect
